import ToolCard from "../components/ToolCard"

export default function Home() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">NLP Tools</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ToolCard id="classify" title="Classification" />
        <br />
        <ToolCard id="summarize" title="Summarization" />
        <br />
        <ToolCard id="nerpos" title="NER / POS" />
      </div>

      <img
        src="./bg.jpg"
        className="object-cover fixed top-0 left-0 w-screen h-screen -z-10 sm:object-fill"
        alt="background"
      />
    </div>
  )
}